var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
var UtilsMixin = /** @class */ (function (_super) {
    __extends(UtilsMixin, _super);
    function UtilsMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @function updateItemsCollection
     * @description Update the items collection by updating or adding the item based on the provided unique keys
     * @param  {object} item: object Item to update or add
     * @param  {string[]} keys: string[] Collection of unique keys for type of item
     * @example this.updateItemsCollection(item, ['id']
     * @example this.updateItemsCollection(anotherItem, ['name', 'description'])
     */
    UtilsMixin.prototype.updateItemsCollection = function (items, item, keys) {
        // no item or keys provided
        if (!items || !item || keys.length === 0) {
            return;
        }
        // get the matching item by key
        var matchingItems = items.filter(function (d) {
            return keys.every(function (key) { return d[key] === item[key]; });
        });
        if (matchingItems.length === 1) {
            // update the existing item in the collection
            var matchingItem = matchingItems[0];
            // update each property
            for (var prop in matchingItem) {
                if (item.hasOwnProperty(prop)) {
                    matchingItem[prop] = item[prop];
                }
            }
        }
        else {
            // add the new item to the collection
            items.push(item);
        }
        return items;
    };
    /**
     * @function getNumericMaskForLength
     * @description Get a mask for a numeric field of a set length
     * @param length length of mask
     */
    UtilsMixin.prototype.getNumericMaskForLength = function (length) {
        return '#'.repeat(length);
    };
    UtilsMixin = __decorate([
        Component
    ], UtilsMixin);
    return UtilsMixin;
}(Vue));
export default UtilsMixin;
